import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  id: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/card/restore',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useRestoreCardLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useRestoreCardLazy;
